import publisher from '@/api/publisher'
import file from '@/api/file'
export default {
  data() {
    return {
      publisher: {},
      domain: ''
    }
  },
  mounted() {
    let publisherId = ''
    // if (!location.hostname.includes('192.168')) {
    //   publisherId = location.hostname.split('.')[0]
    // }
    this.getPublisherInfo(publisherId || 'imr')
    this.getDomain()
  },
  methods: {
    async getPublisherInfo(id) {
      this.publisher = await publisher.query(id)
    },
    async getDomain() {
      this.domain = await file.domain()
    }
  }
}
